export enum ConfigId {
  Employees = "1",
  SystemMgmt = "2",
  DeleteAccountRequest = "3",
  EPRRequest = "4",
  ITCodeGrantRequest = "5",
  RepairITToolRequest = "6",
  ITToolGrantRequest = "7",
  BusinessTicketRequest = "8",
  SercurityControlCardRequest = "9",
  SercurityControlCardExternalRequest = "10",
  BusniessVehicleCardRequest = "11",
  BusniessExternalCardRequest = "12",
  BusinessVehicleRequest = "13",
  Permission = "14",
  AFLRequests = "21",
}

export const configTitles: { [key in ConfigId]: string } = {
  [ConfigId.Employees]: "🤵‍♂️ Cấu hình danh sách nhân viên",
  [ConfigId.SystemMgmt]: "👨‍💻 Cấu hình người phê duyệt",
  [ConfigId.DeleteAccountRequest]: "1️⃣ Cấu hình quy trình xoá tài khoản",
  [ConfigId.EPRRequest]: "2️⃣ Cấu hình quy trình cấp code Amadeus",
  [ConfigId.ITCodeGrantRequest]: "3️⃣ Cấu hình quy trình cấp quyền sử dụng chương trình",
  [ConfigId.RepairITToolRequest]: "4️⃣ Cấu hình quy trình sửa chữa CNTT",
  [ConfigId.ITToolGrantRequest]: "5️⃣ Cấu hình quy trình nhu cầu cấp vật tư, CCDC CNTT",
  [ConfigId.BusinessTicketRequest]: "1️⃣ Cấu hình quy trình cấp vé công tác",
  [ConfigId.SercurityControlCardRequest]: "2️⃣ Cấu hình quy trình cấp thẻ KSAN nội bộ VIAGS",
  [ConfigId.SercurityControlCardExternalRequest]: "3️⃣ Cấu hình quy trình cấp thẻ KSAN cho đơn vị ngoài",
  [ConfigId.BusniessVehicleCardRequest]: "4️⃣ Cấu hình quy trình cấp giấy phép KSAN cho phương tiện VIAGS",
  [ConfigId.BusniessExternalCardRequest]: "5️⃣ Cấu hình quy trình cấp giấy phép KSAN cho đơn vị ngoài",
  [ConfigId.BusinessVehicleRequest]: "6️⃣ Cấu hình quy trình Sử dụng xe công vụ",
  [ConfigId.Permission]: "⚙️ Phân quyền sử dụng",
  [ConfigId.AFLRequests]: "Cấu hình đơn xin nghỉ phép",
};
